import * as React from "react";
export const DetailIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width={44} height={46} viewBox="0 0 44 46" {...props}>
      <path
        fill={"#6d7278"}
        d="M-0.06 23.22C0.05 24.25 0.93 25.02 1.97 25L25.69 25L22.09 28.59C21.66 29.02 21.44 29.61 21.5 30.22C21.57 31 22.1 31.66 22.84 31.91C23.58 32.17 24.4 31.97 24.94 31.41L33.34 23L24.94 14.59C24.44 14.07 23.7 13.86 22.99 14.04C22.29 14.21 21.74 14.76 21.55 15.46C21.37 16.16 21.57 16.9 22.09 17.41L25.69 21L1.97 21C1.43 20.99 0.91 21.2 0.52 21.59C0.14 21.97 -0.07 22.49 -0.06 23.03C-0.07 23.09 -0.07 23.16 -0.06 23.22ZM33 46L38.69 46C40.16 46 41.59 45.55 42.59 44.5C43.59 43.45 44 42 44 40.56L44 5.41C44 3.95 43.59 2.5 42.56 1.47C41.54 0.44 40.06 0 38.59 0L33 0L33 4L38.59 4C39.33 4 39.6 4.16 39.72 4.28C39.84 4.41 40 4.67 40 5.41L40 40.56C40 41.32 39.83 41.6 39.72 41.72C39.61 41.84 39.41 42 38.69 42L33 42L33 46Z"
      />
    </svg>
  );
};
